import { Link } from "react-router-dom";
import type { Category } from "@/mocks/categories";

interface CategoryBadgeProps {
  category: Category;
  active?: boolean;
  onClick?: () => void;
  asLink?: boolean;
}

export default function CategoryBadge({ category, active = false, onClick, asLink = true }: CategoryBadgeProps) {
  const content = (
    <div
      className={`flex items-center gap-2 px-4 py-2.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap ${
        active
          ? "bg-primary-500/20 text-primary-400 ring-1 ring-primary-500/30"
          : "bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200/50"
      }`}
      onClick={onClick}
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className={`${category.icon} text-base`}></i>
      </div>
      <span className="text-sm font-medium">{category.name}</span>
      <span className={`text-xs ml-auto ${active ? "text-primary-400/70" : "text-foreground-600"}`}>
        {category.articleCount}
      </span>
    </div>
  );

  if (asLink && !onClick) {
    return <Link to={`/category/${category.slug}`}>{content}</Link>;
  }

  return content;
}